<button
    class="back-button"
    aum-icon-button
    icon="round-back"
    color="basic"
    (click)="onClickBack()"
    [size]="size"
></button>
<button
    class="forth-button"
    aum-icon-button
    icon="round-forth"
    color="basic"
    (click)="onClickForth()"
    [size]="size"
></button>
